<template>
    <section>
      <div class="container">
        <div class="row jumbo" :style="{ backgroundImage: 'url(' + background + ')' }">
        </div>
        <div class="row paragrafi">
          <div class="col-md-8 col-12">
            <p class="main">
             {{trans.get('public.fesr.main')}}
            </p>
            <p>
              {{trans.get('public.fesr.par1')}}
            </p>
            <p>
              {{trans.get('public.fesr.par2')}}
            </p>
            <p>
              {{trans.get('public.fesr.par3')}}
            </p>
            <p>
              {{trans.get('public.fesr.par4')}}
            </p>
            <p>
              {{trans.get('public.fesr.par5')}}
            </p>
            <p>
              {{trans.get('public.fesr.par6')}}
            </p>
            <p>
              {{trans.get('public.fesr.par7')}}
            </p>
            <p>
              {{trans.get('public.fesr.par8')}}
            </p>
            <p>
              {{trans.get('public.fesr.par9')}}
            </p>
          </div>
          <div class="col-md-4 col-12 images">
            <img :src="url('/storage/media/fesr_image_1.jpg')" alt="">

            <img :src="url('/storage/media/fesr_image_2.jpg')" alt="">
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "fesr",
  data() {
    return {
      background: '/storage/media/banner_fesr.jpg',
    }
  },
  mounted() {
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
section {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  color: var(--text-white);
  width: 100vw;
  background-color: var(--dark-gray);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 576px){
    justify-content: center;
  }
  .container {
    max-width: calc(100% - var(--public-menu-width))!important;
    width: 100%;
    margin: 0;
    margin-top: 65px;
    padding: 0;
    padding-left: 10px;
    @media (max-width: 576px) {
      max-width: 100%!important;
    }
  }
  .row {
    width: 90%;
    max-width: 100%;
    &.jumbo {
      background-color: #FFFFFF;
      background-repeat: no-repeat;
      background-size: contain;
      width: 100%;
      height: 200px;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 100px;
      @media (max-width: 576px){
        background-size: 120%;
        height: 50px;
        background-position-x: 65%;
        margin-bottom: 50px;
      }
    }
    &.paragrafi {
      p {
        margin-bottom: 30px;
      }
      p.main {
        font-size: 1.3rem;
        font-weight: bold;
      }
      .images {
        img {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
